<template>
  <header class="app-header navbar">
    <div>{{announcementStatus}}</div>
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarMinimize">&#9776;</button>
    <b-nav is-nav-bar class="ml-auto">
      <span v-if="announcementStatus === 0" style="background-color: #34383c;border-bottom: 1px solid #34383c;cursor: pointer;"  title="Announcement"  @click="showAnnouncement"><span style="color: white"><i class="fa fa-bell"></i></span></span>&emsp;
      <span style="color: white">{{$auth.user().name}}</span>
      <b-nav-item-dropdown class="avatar" right>
        <template slot="button-content">
          <img src="/static/img/user.png" class="img-avatar" alt="">
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
        <!-- <b-dropdown-item v-if="$auth.user().roles[0] === 'ADMIN'" v-on:click="setting()"><i class="fa fa-cog"></i>Setting</b-dropdown-item> -->
        <b-dropdown-item v-on:click="logout()"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-nav>
    <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">&#9776;</button>
  </header>
</template>
<script>
export default {
  name: 'header',
  data () {
    return {
      announcementStatus: 1
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    logout () {
      this.$auth.logout({
        makeRequest: true,
        success: function () {
          console.log('logged out')
        },
        redirect: '/login'
      })
    },
    setting () {
      this.$router.push({path: '/setting'})
    },
    showAnnouncement () {
      this.$bus.$emit('show-announcement')
    },
    getAnnouncementDetails () {
      console.log('getAnnouncementDetails -> getAnnouncementDetails')
      this.$http.get('admin/announcement-content').then(response => {
        this.announcementStatus = parseInt(response.body[1]['setting_value'])
        console.log('getAnnouncementDetails -> this.announcementStatus', this.announcementStatus)
      }, response => {
        console.log(response)
      })
    }
  },
  created () {
    this.getAnnouncementDetails()
  }
}
</script>

<style lang="css">
  .avatar .dropdown-toggle::after  {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/MetalMarketHeader.vue